import { TelagriLogo } from '@assets/icons/TelagriLogo';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import Cookies from 'js-cookie';

interface LoginHeaderProps {
	title?: string;
	spacing?: string;
	wrapperSpacing?: string;
}

export const AuthHeader = ({
	title,
	spacing = 'mt-0',
	wrapperSpacing = 'mb-[30px]',
}: LoginHeaderProps) => {
	const { navigateWithLanguage } = useLanguageNavigate();

	const handleLogoClick = () => {
		// Clear authentication tokens to ensure user lands on login page
		Cookies.remove('accessToken');
		localStorage.removeItem('refreshToken');
		navigateWithLanguage('/login');
	};

	return (
		<div className={`flex flex-col items-center ${wrapperSpacing}`}>
			<div className="cursor-pointer" onClick={handleLogoClick}>
				<div className="w-[200px] h-[61px] max-sm:w-[150px] max-sm:h-[45px]">
					<TelagriLogo />
				</div>
			</div>
			{title && (
				<h1
					className={`text-2xl !font-roboto-slab sm:text-2xl roboto-bold text-dark uppercase ${spacing}`}
				>
					{title}
				</h1>
			)}
		</div>
	);
};
